import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

// Create the casino API service
export const casinoApi = createApi({
  reducerPath: 'casinoApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Casino', 'Results'],
  endpoints: (builder) => ({
    // Get Teen20 result history endpoint
    getTeen20Results: builder.query({
      query: () => ({
        url: '/api/result/teen20',
        method: 'GET',
      }),
      providesTags: ['Results'],
    }),
    
    // Get inplay bets for casino games
    getInplayBets: builder.query({
      query: (game = 'teen20') => ({
        url: `/api/casino/admin/inplay-bets?game=${game}`,
        method: 'GET',
      }),
      providesTags: ['Casino'],
    }),
    
    // Get casino rounds by game
    getCasinoRounds: builder.query({
      query: ({ game = 'teen20', page = 1, limit = 20, fromDate, toDate }) => {
        const params = new URLSearchParams({ game, page, limit });
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate)   params.append('toDate',   toDate);
        return { url: `/api/casino/admin/rounds?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Casino'],
    }),
    
    // Get round bets by roundId
    getRoundBets: builder.query({
      query: (roundId) => ({
        url: `/api/casino/admin/round-bets?roundId=${roundId}`,
        method: 'GET',
      }),
      providesTags: ['Casino'],
    }),
    
    // Get casino game list (for the game-select dropdown)
    getGameList: builder.query({
      query: () => ({
        url: '/api/casino/admin/game-list',
        method: 'GET',
      }),
      providesTags: ['Casino'],
    }),

    // Get completed casino games
    getCompletedGames: builder.query({
      query: ({ fromDate, toDate, page = 1, limit = 20, game } = {}) => {
        const params = new URLSearchParams();
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate) params.append('toDate', toDate);
        if (game) params.append('game', game);
        params.append('page', page);
        params.append('limit', limit);
        return {
          url: `/api/casino/admin/completed-games?${params.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['Casino'],
    }),
    
    // Get company report for casino
    getCompanyReport: builder.query({
      query: ({ game, userId, fromDate, toDate }) => ({
        url: '/api/casino/admin/company-report',
        method: 'GET',
        params: { game, userId, fromDate, toDate },
      }),
      providesTags: ['Casino'],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetTeen20ResultsQuery,
  useGetInplayBetsQuery,
  useGetCasinoRoundsQuery,
  useGetRoundBetsQuery,
  useGetGameListQuery,
  useGetCompletedGamesQuery,
  useGetCompanyReportQuery,
} = casinoApi;
